export default __webpack_public_path__ + "static/media/contactAreaImage.86d2da33.jpg";